import React from 'react';
import PropTypes from 'prop-types';
import { SCategoryName } from './styles';
import { Link } from 'gatsby';

const CategoryName = ({ inverse, name, slug, isPodcast }) => {
  return (
    <SCategoryName inverse={inverse}>
      <Link
        to={`/${isPodcast ? 'podcast/episodes' : 'blog/categories'}/${slug}/1/`}
      >
        {name}
      </Link>
    </SCategoryName>
  );
};

CategoryName.propTypes = {
  inverse: PropTypes.bool,
  isPodcast: PropTypes.bool,
  name: PropTypes.string,
  slug: PropTypes.string,
};

export default CategoryName;
